import AmTypography from "./Typography.vue";
import "./style.scss";

export { AmTypography };
